import React from 'react'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import KeyValueSection from '../SearchInputTriggerKeyValue'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'

interface Props {
  dateValue?: moment.Moment;
  label: string;
  placeholder: string;
}

/**
 * UI component to show label / placeholder / formatted date value if date is selected
 * @param dateValue - selected date
 * @param label - label shown as heading
 * @param placeholder - placeholder shown when no date selected
 */
function DateInputValue({ dateValue, label, placeholder }: Props) {
  return (
    <KeyValueSection>
      <Caption variant="large" weight="bold" colour="neutral-one">{label}</Caption>
      {!dateValue &&
        <BodyText colour="neutral-two" variant="medium">{placeholder}</BodyText>}
      {dateValue &&
        <BodyText colour="neutral-one" variant="medium">
          {moment(dateValue).format(DMY_CASUAL_FORMAT)}
        </BodyText>
      }
    </KeyValueSection>
  )
}

export default DateInputValue
